import { createI18n } from 'vue-i18n'

const messages = Object.fromEntries(
  Object.entries(import.meta.glob('/src/locales/*.json', { eager: true})).map(([key, value]) => {
    // @ts-ignore
    return [key.split('/').pop()!.replace('.json', ''), value.default]
  })
)

export const install = (app: any) => {
  const i18n = createI18n({
    locale: 'en',
    messages,
  })
  app.use(i18n)
}
